const KEY_PREFIX_V1 = 'welya-live-admin-screen-share:';

/**
 * La room LiveKit survit 15 min à un départ (emptyTimeout / departureTimeout côté back).
 * Passé ce délai la room est morte : proposer une reprise n'aurait plus de sens.
 */
export const SCREEN_SHARE_RESUME_WINDOW_MS = 15 * 60 * 1000;

function storageKey(sessionId: number): string {
  return `${KEY_PREFIX_V1}${sessionId}`;
}

export function markScreenShareIntent(sessionId: number, at: number): void {
  try {
    if (!Number.isFinite(at)) return;
    globalThis.localStorage?.setItem(storageKey(sessionId), String(Math.floor(at)));
  } catch {
    console.error('Error marking screen share intent', sessionId);
  }
}

export function clearScreenShareIntent(sessionId: number): void {
  try {
    globalThis.localStorage?.removeItem(storageKey(sessionId));
  } catch {
    console.error('Error clearing screen share intent', sessionId);
  }
}

export function getScreenShareIntentAt(sessionId: number): number | undefined {
  try {
    const raw = globalThis.localStorage?.getItem(storageKey(sessionId));
    if (raw == null) return undefined;
    const n = Number.parseInt(raw, 10);
    if (!Number.isFinite(n) || n <= 0) return undefined;
    return n;
  } catch {
    return undefined;
  }
}

/** Aligne la mémoire sur la réalité publiée (clôture, démarrage de live, trace résiduelle). */
export function reconcileScreenShareIntent(
  sessionId: number,
  isSharing: boolean,
  at: number,
): void {
  if (isSharing) {
    markScreenShareIntent(sessionId, at);
  } else {
    clearScreenShareIntent(sessionId);
  }
}

/**
 * Le partage était voulu mais n'est plus publié (rechargement, coupure) : on propose la reprise.
 * Un navigateur ne peut pas relancer une capture d'écran sans geste utilisateur.
 */
export function shouldOfferScreenShareResume({
  intentAt,
  now,
  isPublishing,
}: {
  intentAt: number | undefined;
  now: number;
  isPublishing: boolean;
}): boolean {
  if (isPublishing) return false;
  if (intentAt == null) return false;
  const elapsed = now - intentAt;
  if (elapsed < 0) return false;
  return elapsed <= SCREEN_SHARE_RESUME_WINDOW_MS;
}
